document.addEventListener( 'DOMContentLoaded', function () {
  const sections = document.querySelectorAll( '.tabbed-contents' );

  sections.forEach( section => {
    const tabs = section.querySelectorAll( '.tabbed-contents__tab' );
    const contents = section.querySelectorAll( '.tabbed-contents__content' );

    if ( tabs.length === 0 || contents.length === 0 ) return;

    tabs[ 0 ].classList.add( 'tabbed-contents__tab--active' );
    contents[ 0 ].classList.add( 'tabbed-contents__content--active' );

    tabs.forEach( ( tab, index ) => {
      tab.addEventListener( 'click', () => {
        if ( tab.classList.contains( 'disabled' ) ) return;

        tabs.forEach( t => t.classList.remove( 'tabbed-contents__tab--active' ) );
        contents.forEach( c => c.classList.remove( 'tabbed-contents__content--active' ) );

        tab.classList.add( 'tabbed-contents__tab--active' );
        if ( contents[ index ] ) {
          contents[ index ].classList.add( 'tabbed-contents__content--active' );
        }
      } );
    } );
  } );
} );
